"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransLang = exports.isI18NEnv = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.default = transLoader;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANG = "LANG";

var isI18NEnv = exports.isI18NEnv = function isI18NEnv() {
  return window["BSGlobal"] && window["BSGlobal"]["I18NInfo"] && window["BSGlobal"]["I18NInfo"]["I18NUserLang"];
};

/**
 * 根据翻译的 key 和字典中的 key 返回相应的翻译
 * @param keyMap 组件中文本 key 与字典中 key 的对应
 */
function transLoader(keyMap) {
  // 判断是否存在i18N的多语言语言配置
  if (isI18NEnv()) {
    // 当工具函数存在时，返回赋值之后的keyMap
    if (window["_BSI18NTools"]) {
      var getTrans = function getTrans(key) {
        return window["_BSI18NTools"].getTrans(key);
      };
      var translation = {};
      (0, _keys2.default)(keyMap).forEach(function (transKey) {
        var dictKey = keyMap[transKey];
        // 当传入的字典 key 为LANG时，直接返回语言
        if (dictKey === LANG) {
          translation[transKey] = getTransLang();
          return;
        }
        var keyValue = getTrans(dictKey);
        if (keyValue) {
          translation[transKey] = keyValue;
        }
      });
      return translation;
    }
  }
  return undefined;
}
/**
 * @returns { string } 获取多语言配置参数中的语言配置，当不存在多语言配置参数时，返回zh_CN
 */
var getTransLang = exports.getTransLang = function getTransLang() {
  return isI18NEnv() ? BSGlobal.I18NInfo.I18NUserLang : "zh_CN";
};


//////////////////
// WEBPACK FOOTER
// ./~/@beisen/i18n-translation-loader/lib/index.js
// module id = 11
// module chunks = 1